// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__3skE5","paramInput":"JobSimulator_paramInput__3HmS9","input":"JobSimulator_input__1SsrC"};